/**
 * Notification chime (Web Audio API) — no audio file needed.
 *
 * A single AudioContext is created lazily and reused. Browsers block audio until
 * a user gesture, so callers must pair playChime() with a user-initiated
 * unlockAudio() (e.g. an "Enable sound" toggle) before alerts will be audible.
 * Used by the Kitchen Display (ER-MOM-05) for the new-order alert.
 */

let ctx = null;

function getCtx() {
  if (ctx) return ctx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  try { ctx = new AC(); } catch { ctx = null; }
  return ctx;
}

/** Resume the AudioContext from within a user gesture. Returns true if audible. */
export async function unlockAudio() {
  const c = getCtx();
  if (!c) return false;
  if (c.state === 'suspended') {
    try { await c.resume(); } catch { return false; }
  }
  return c.state === 'running';
}

/** Play a two-tone "beep-boop" chime, optionally repeated for a busy kitchen. */
export function playChime(repeat = 1) {
  const c = getCtx();
  if (!c) return;
  if (c.state === 'suspended') { c.resume().catch(() => {}); }
  const tones = [660, 880];
  for (let r = 0; r < repeat; r++) {
    tones.forEach((freq, i) => {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.connect(gain);
      gain.connect(c.destination);
      osc.type = 'sine';
      osc.frequency.value = freq;
      const t = c.currentTime + r * 0.5 + i * 0.18;
      gain.gain.setValueAtTime(0.22, t);
      gain.gain.exponentialRampToValueAtTime(0.001, t + 0.32);
      osc.start(t);
      osc.stop(t + 0.34);
    });
  }
}
